export default __webpack_public_path__ + "static/media/chart-3 1.469db66d.svg";